import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import NavbarComponent from '../../components/NavbarComponent';
import FooterComponent from '../../components/FooterComponent';
import { FaBook, FaCompass } from 'react-icons/fa';
import styled from 'styled-components';

const PageContainer = styled.div`
  background: #000;
  min-height: 100vh;
  color: #fff;
  font-family: 'Nunito Sans', sans-serif;
  padding-top: 40px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: #FF7C24;
  text-align: center;
  margin-bottom: 32px;
`;

const OptionCard = styled.div`
  display: flex;
  align-items: flex-start;
  background-color: ${props => (props.selected ? '#2ECC71' : '#1e1e1e')};
  color: #fff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.03);
  }
`;

const OptionIcon = styled.div`
  font-size: 28px;
  margin-right: 16px;
  margin-top: 4px;
`;

const OptionContent = styled.div`
  flex: 1;
`;

const OptionTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
`;

const OptionDescription = styled.p`
  font-size: 14px;
  font-weight: normal;
  margin-top: 4px;
  color: #ccc;
`;

const ContinueButton = styled.button`
  background-color: ${props => (props.disabled ? '#ccc' : '#FF7C24')};
  border: none;
  color: ${props => (props.disabled ? '#777' : '#fff')};
  font-size: 18px;
  font-weight: bold;
  padding: 14px 32px;
  border-radius: 12px;
  margin-top: 30px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.3s ease;
  &:hover {
    transform: ${props => (props.disabled ? 'none' : 'scale(1.05)')};
  }
`;

const FindMySkillLevelStep2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedCourse = location.state?.selectedCourse || { coursename: "this course" };

  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleContinue = () => {
    if (!selectedOption) {
      alert('Please select an option before continuing.');
      return;
    }
    navigate('/get-ready-skill-test', { state: { selectedCourse, selectedOption } });
  };

  return (
    <>
      <NavbarComponent />
      <PageContainer>
        <Container>
          <Title>Where would you like to start?</Title>

          <OptionCard
            onClick={() => handleOptionSelect("start_from_scratch")}
            selected={selectedOption === "start_from_scratch"}
          >
            <OptionIcon><FaBook /></OptionIcon>
            <OptionContent>
              <OptionTitle>Start from scratch</OptionTitle>
              {/* <OptionDescription>
                Take the easiest lesson of the {selectedCourse.coursename} course
              </OptionDescription> */}
            </OptionContent>
          </OptionCard>

          <OptionCard
            onClick={() => handleOptionSelect("find_my_level")}
            selected={selectedOption === "find_my_level"}
          >
            <OptionIcon><FaCompass /></OptionIcon>
            <OptionContent>
              <OptionTitle>Find my level</OptionTitle>
              <OptionDescription>
                Let FinTorro recommend where you should start learning
              </OptionDescription>
            </OptionContent>
          </OptionCard>

          <div className="text-center">
            <ContinueButton
              onClick={handleContinue}
              disabled={!selectedOption}
            >
              Continue
            </ContinueButton>
          </div>
        </Container>
      </PageContainer>
      <FooterComponent />
    </>
  );
};

export default FindMySkillLevelStep2;

